import { VisionKey } from '@wizeoo/akm-message-lib';

import { WizConstants } from '../../model/constants';
import { DATA_KIND } from '../../model/enums';
import { ChronocodeVO } from '../core/chronocode.vo';
import { FreeDataVO } from '../core/freedata.vo';
import { Model } from '../../model/model';

/**
 * VO représentant une clé de vision (Freedata ou Chronocode)
 */
export class VisionKeyVO {

  protected _model: Model;
  
  constructor(model: Model, pSource: VisionKey) {
    this._model = model;
    this._source = pSource;
    this.build(model);
  }

  /** L'objet source provenant du back */
  protected _source: VisionKey;

  public get source(): VisionKey {
    return this._source;
  }
  public set source(value: VisionKey) {
    this._source = value;
  }

  public get code(): string {
    return this._source.code;
  }

  public get order(): number {
    return this._source.order;
  }

  /** step d'appartenance */
  public get stepLevel(): number {
    return this._source.stepLevel;
  }
  public set stepLevel(value: number) {
    this._source.stepLevel = value;
  }

  
  public dataKind: string; // le type de données, précis (Int, Number, Date, Bool, String)

  public isFD: boolean = false; // c'est un FD

  public isChrono: boolean = false; // c'est un chronocode

  private _relatedFd: FreeDataVO = null; // le freedataSource. Level 1 pour les collection plates

  private _relatedChrono: ChronocodeVO = null; // le chronocodeLevel source.

  /* ################################################
   *    init : définition du type et des labels
   * ################################################ */
  private build(model: Model) {
    if (this.code?.startsWith('CHRONO')) {
      // La key est liée à un chronocodelevel
      this._relatedChrono = model.chronocodeEngine.getChronocode(this._source.chronoCode);
      this.isChrono = true;
      this.dataKind = DATA_KIND.DATE;
    } else {
      // la key est liée à un freeData
      const fdv: string = this.code.split(WizConstants.CONTEXT_SEPARATOR)[0]; // prise du code
      this._relatedFd = model.freedataEngine.getFreeData(fdv);
      this.isFD = true;
      this.dataKind = this._relatedFd?.dataType;
    }
  }

  /* ############################################
   *       Collecte des VOs
   * ############################################ */

  public getRelatedFd(): FreeDataVO {
    return this._relatedFd;
  }

  public getRelatedChrono(): ChronocodeVO {
    return this._relatedChrono;
  }

}
